import styled from '@emotion/styled';
import Link, { LinkProps } from 'next/link';
import { AriaRole, MouseEventHandler, ReactNode } from 'react';

type PropsType = {
    children: ReactNode;
    href: LinkProps['href'];
    linkAs?: LinkProps['as'];
    className?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    scroll?: boolean;
    role?: AriaRole;
    title?: string;
};

const SLink = styled(Link)`
    text-decoration: none;
`;

const InternalLink = ({
    children,
    href,
    linkAs,
    className,
    onClick,
    scroll = true,
    role,
    title,
}: PropsType) => {
    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.stopPropagation();
        onClick?.(event);
    };

    return (
        <SLink
            href={href}
            as={linkAs}
            passHref
            scroll={scroll}
            className={className}
            onClick={handleClick}
            tabIndex={0}
            role={role}
            title={title}
        >
            {children}
        </SLink>
    );
};

export default InternalLink;
